import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SCREEN } from '../../../../../assets/styles/constants';
import { isSafari } from '../../../../../lib/helpers';
import { ColorsVariables } from '../../../../../assets/styles/colors';

const myMessageBoxCSS = css`
	align-self: flex-end;
	color: #383838;
	text-align: right;
`;
const opponentMessageBoxCSS = css`
	align-self: flex-start;
	color: ${ColorsVariables.MainGreen};
	text-align: left;
`;
const chatWindowTopOffset = 110;
const decideHeight = (viewPortHeight) => {
	if (viewPortHeight < 420) {
		return isSafari ? viewPortHeight : viewPortHeight - 65;
	}
	return viewPortHeight - chatWindowTopOffset;
};
export const ChatWindowWrapper = styled.div`
	box-shadow: 0 2px 11px 2px rgba(0, 0, 0, .1);
	width: 288px;
	height: 349px;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	${props => !props.visible && 'display: none;'}
	${SCREEN.SMALL}{
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background: white;
		z-index: 3;
		width: 100%;
		height: ${props => decideHeight(props.viewportHeight)}px;
		
	}
`;
export const ChatWindowHeader = styled.div`
	padding: 0 15px;
	height: 55px;
	font-size: 20px;
	color: #383838;
	box-shadow: 0 0 11px 2px rgba(0, 0, 0, .09);
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const ChatWindowFooter = styled.div`
	position: relative;
	height: 47px;
	border-top: 1px solid #D8D8D8;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const Message = styled.div`
	font-size: 16px;
	margin-bottom: 10px;
	${props => (props.myMessage ? myMessageBoxCSS : opponentMessageBoxCSS)}
`;
export const ChatTextInput = styled.input`
	appearance: none;
	height: 100%;
	width: 100%;
	border: unset;
	background: transparent;
	padding: 12px 15px;
	line-height: inherit;
	font-size: 16px;
	outline: none;
	&::placeholder{
		color: #89929F
	}
`;
export const SendIcon = styled(FontAwesomeIcon)`
	cursor: pointer;
	margin-right: 10px;
`;
export const Form = styled.form`
  	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const ChatWindowContent = styled.div`
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding: 10px 15px;
	flex: 1;
`;

export const CloseButton = styled.button`
	appearance: none;
	padding: 0 3px;
	cursor: pointer;
`;
